<template>
  <div class="videoExamine-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.title"
        placeholder="请输入标题"
        clearable
        @keyup.enter.native="getAvCommentList()"
        size="small"
        class="param-input">
      </el-input>
      <el-button type="primary" size="small" @click="getAvCommentList()">
        搜索
      </el-button>
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      ref="multipleTable"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="550">
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="desc"
        label="描述"
        align="center"
        width="300">
      </el-table-column>
      <el-table-column
        prop="price"
        label="价格"
        align="center"
        width="70">
      </el-table-column>
      <el-table-column
        prop="period"
        label="期数"
        align="center"
        width="70">
      </el-table-column>
      <el-table-column
        label="封面图"
        align="center"
        width="200"
        prop="cover">
        <template slot-scope="scope">
          <img-load
            :width="'80px'"
            :height="'60px'"
            :src="imgUrl + scope.row.cover">
          </img-load>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="视频审查" align="center" width="120">
        <template slot-scope="scope">
          <i class="el-icon-video-play views" title="点击预览"
            @click="checkMedia(scope.row.sourceURL, 'video', scope.row)">
          </i>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        label="图文预览"
        align="center"
        width="120">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="getEditorData(scope.row)">
            预览
          </el-button>
          <el-button type="danger" size="mini" icon="el-icon-edit" @click="lookEidt(scope.row)">
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="是否启用"
        align="center"
        width="100"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.active === true ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        width="160"
        :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="更新时间"
        align="center"
        width="160"
        :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="edit(scope.row)">
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5, 10, 15, 20]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 1"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>

    <!--封面图、视频弹窗组件-->
    <preview-video ref="previewVideo"></preview-video>
    <!--视频编辑弹窗-->
    <edit-video ref="editVideo" @handlerAvCommentList="handlerAvCommentList"></edit-video>
    <!--预览-->
    <look ref="look"></look>
  </div>
</template>
<script>
import PreviewVideo from "./components/preview-video";
import EditVideo from "./components/edit-video";
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import Look from './components/look'
export default {
  data() {
    return {
      loading: false,
      total: 0,
      imgUrl: baseConfig.imgUrl,
      // 请求列表查询
      params: {
        pageNumber: 1,
        pageSize: 10,
        title: "",
      },
      // 列表数据
      tableData: [],
    };
  },
  components: {
    PreviewVideo,
    EditVideo,
    Look,
  },
  created() {
    this.getAvCommentList();
  },
  methods: {
    handlerPreviewList() {
      this.getAvCommentList();
    },
    // 获取视频列表
    getAvCommentList() {
      this.loading = true;
      API.getAvCommentList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            //图片源站地址
            if(res.data.list.length > 0) {
              for (let i = 0; i < res.data.list.length; i++) {
                var graphic = res.data.list[i].graphic
                if(graphic != "") {
                  res.data.list[i].graphic = graphic.replace(/<img src="/g,"<img src=\"https://yuan.dhuqh.com/")
                }
              }
            }
            this.tableData = res.data.list;
            
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getAvCommentList();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getAvCommentList();
    },
    // 新增视频成功回调
    handlerLoadList() {
      this.getAvCommentList();
    },
    // 视频查看
    checkMedia(url, type, data) {
      this.$refs.previewVideo.open(url, type, data);
    },
    // 新增视频
    addVideo() {
      this.$refs.addVideo.open();
    },
    getEditorData(row) {
      // 通过代码获取编辑器内容
      let data = row.graphic
      this.$refs.look.open(data)
    },
    // 编辑回调监听
    handlerAvCommentList() {
      this.getAvCommentList();
    },
    edit(row) {
      this.$refs.editVideo.open(row);
    },
    //跳转编辑
    lookEidt(row) {
      this.$router.push({
        name: 'avCommentConfig',
        params: {
          id: row.id,
          graphic: row.graphic
        }
      })
    }
  },
};
</script>

<style lang="scss">
.videoExamine-box {
  .views {
    font-size: 20px;
    color: #e63765;
    cursor: pointer;
    &:hover {
      color: #eb5f84;
    }
  }
  .edit {
    font-size: 18px;
    cursor: pointer;
    color: #e63765;
    vertical-align: middle !important;
    &:hover {
      color: #eb5f84;
    }
  }
  .cell {
    overflow: hidden;
  }
  .tags {
    font-size: 12px;
    margin-right: 5px;
  }
  .action-bar {
    width: 100%;
    height: 30px;
    font-size: 14px;
    color: #666;
    margin-bottom: 50px !important;
    .el-select {
      width: 150px;
      margin-right: 10px;
    }
    .el-button {
      margin-left: 10px;
    }
    .block {
      margin-top: 30px;
    }
    .param-input {
      width: 180px;
      margin-right: 10px;
    }
  }
  .picturePreview {
    max-width: 300px;
    display: flex;
  }
}
</style>
